﻿import { defineComponent, PropType } from 'vue';

import { Product } from "../../../services/product";

import { pickup } from '../../../objects/v1_3/product/pickup/pickup';
import { product_detail } from '../../../objects/v1_3/product/product/product_detail';
import { pickup_point } from '../../../objects/v1_3/product/pickup/pickup_point';
import { Capacity } from "../../../services/capacity";
import { booking_group } from "../../../objects/v1_2/Booking/Booking_Group"
import { trip } from "../../../objects/v1_2/Booking/Trip";

let Prod = new Product();
const Capa = new Capacity();

export default defineComponent({
    name: "pickup_points",
    props: {
        pickup_id: String,
        trip_index: Number
    },
    data() {
        return {
            pickup_points: new pickup() as pickup,
            isOpen: false as Boolean,
            selected_pickup_point: new pickup_point() as pickup_point,
            product_details: new product_detail() as product_detail,
            pickup_options: [] as Array<{ id: string; DisplayName: string }>,
            capacityCache: {} as Record<string, any>
        }
    },
    methods: {
        async Download_Pickup_Points(tour_id: string) {
            this.product_details = await Prod.Get_Details(tour_id, this.$store);

            this.pickup_points = new pickup();
            if (this.product_details.operational_information.pickup_run_id != null) {
                this.pickup_points = await Prod.Get_Pickup_Points(this.product_details.operational_information.pickup_run_id);

                this.pickup_points.points.sort((first, second) => {
                    return 0 - ((first.name ?? "") > (second.name ?? "") ? -1 : 1)
                });
            }
            await this.updatePickupOptions();
        },
        async getPickupDepartureTimes(tour_id: string, minutes_before: number | null): Promise<string> {
            let trip_date = this.get_Trip_Date();
            let pickup_time = "";
            let start_time = "";

            if (trip_date !== "" && minutes_before !== null) {
                let departureYear = Number(trip_date.split("/")[0] ?? "");
                let departureMonth = Number(trip_date.split("/")[1] ?? "");

                const cacheKey = `${tour_id}_${trip_date}`;
                let capacities;

                if (this.capacityCache[cacheKey]) {
                    capacities = this.capacityCache[cacheKey];
                } else {
                    capacities = (await Capa.Get_Capacity(tour_id, departureYear, departureMonth)).capacities;
                    this.capacityCache[cacheKey] = capacities;
                }

                capacities.forEach((capacity) => {
                    const capacityDate = capacity.start_date_time
                        ? (() => {
                            const [datePart] = capacity.start_date_time.split(" ");
                            const [year, month, day] = datePart.split("-");
                            return `${year}/${Number(month)}/${Number(day)}`;
                        })()
                        : "";

                    if (capacityDate === trip_date) {
                        start_time = capacity.start_date_time?.split(" ")[1] ?? "";
                        if (start_time) {
                            const [hours, minutes] = start_time.split(":").map(Number);
                            const totalMinutes = hours * 60 + minutes - minutes_before;
                            const newHours = ((Math.floor(totalMinutes / 60) % 24) + 24) % 24;
                            const newMinutes = ((totalMinutes % 60) + 60) % 60;
                            pickup_time = `${newHours.toString().padStart(2, "0")}:${newMinutes.toString().padStart(2, "0")}`;
                        }
                    }
                });
            }

            return pickup_time;
        },
        get_Trip_Date(): string {
            let tripInstance = new trip();
            this.$store.getters.get_Basket.trips.forEach((tripItem: trip) => {
                if (tripItem.tour_id == this.product_details.tour_id) {
                    tripInstance = tripItem;
                }
            });
            return tripInstance.departure_date ?? "";
        },
        async setPickupDisplayName(pickup_point: pickup_point) {
            let display_name: string = pickup_point.name ?? "";
            let start_time = "";

            if (this.product_details.tour_id && pickup_point?.minutes_before != null)
            {
                start_time = await this.getPickupDepartureTimes(this.product_details.tour_id, pickup_point.minutes_before);
                await Promise.resolve();
            }

            if (start_time !== "" && start_time !== "00:00") {
                display_name += " - " + start_time;

            }
            
            this.pickup_options.push({ id: pickup_point.point_id ?? "", DisplayName: display_name });
        },
        getPickupDisplayName(pickup_point: pickup_point): string {
            return this.pickup_options.find((option) => option.id === pickup_point.point_id)?.DisplayName ?? "";
        },
        async updatePickupOptions() {
            this.pickup_options = [];
            if (this.pickup_points?.points?.length) {
                for (const point of this.pickup_points.points) {
                    await this.setPickupDisplayName(point);
                }
            }
        },
        trip_starts(departure_date: string, tour_id: string) {
            return Prod.trip_starts(departure_date, Prod.Get_Details_Sync(tour_id, this.$store));
        },
        display_pickup_points(): boolean {
            return this.pickup_points?.points?.length > 0;
        },
        Pickup_Click(pickup_point: pickup_point) {
            this.selected_pickup_point = pickup_point;
            this.isOpen = false;

            this.$store.commit("Initialise_Pickup_Point", { Trip_Index: this.get_Trip_Index(),  Pickup_Point: pickup_point });
        },
        get_Trip_Index(): number {
            return this.trip_index ?? 0;
        },
        onClickAway(event: any) {
            let Click_Away: boolean = true;

/*            if (event.path[1].id == "Pickup_Point_Click_Away") {
                Click_Away = false;
            }*/

            if (Click_Away == true) {
                this.isOpen = false;
            }
        }
    },
    mounted() {
    },
    watch: {
        '$store.getters.get_Basket.trips': {
            handler() {
                this.capacityCache = {}; // Clear cache on trip update
                this.updatePickupOptions();
            },
            deep: true,
            immediate: true,
        }
    },
    computed: {
        hasTripDate(): boolean {
            return this.get_Trip_Date() !== "";
        }
    }
})